import { render, staticRenderFns } from "./TransactionDocumentsForm.vue?vue&type=template&id=7cde0474"
import script from "./TransactionDocumentsForm.vue?vue&type=script&lang=js"
export * from "./TransactionDocumentsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports